<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('configurations.change_password')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2">
             <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.old_password')}}</label>
              <el-form-item prop="old_password">
                <el-input
                  clearable
                  show-password
                  autocomplete="off"
                  type="text"
                  class="w-full"
                  v-model="form.old_password"
                  maxlength='50'
                />
              </el-form-item>
              <base-password-form-item v-model="form.password" />
              <base-password-form-item v-model="form.repeat_password" :password="form.password" repeat />
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" text="Cancelar" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" text="Aplicar" @click="handleClick('ruleForm')" :loading="isGeneralLoading"/>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from './base/BaseDialog.vue'
import { newPassword } from '@/services/auth/newPassword'
import { i18n } from '@/i18n'

export default
{
  name: 'user-generate-password-dialog',
  components: {
    BaseDialog
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        old_password: '',
        password: '',
        repeat_password: ''
      },
      rules: {
        old_password: [
          {
            required: true,
            message: i18n.t('validation.complete'),
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    }
  },
  mounted: async function () {
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.form.old_password = ''
      this.form.password = ''
      this.form.repeat_password = ''
      this.$emit('toggleDialog')
    },
    handleClick: async function (ruleForm) {
      try {
        this.$store.commit('setAjaxRequestPending', true)
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            const response = await newPassword(this.form.old_password, this.form.password)
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.doFeedback(i18n.t('feedback.success.password_changed_msg'), 'success')
              this.toggleDialog()
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
